import React, { Fragment } from 'react'

import i18n from 'i18next'
import numeral from 'numeral'

import { bool, number, string } from 'prop-types'

function DiscountInfo({ isCartBelowThreshold, potentialDiscount, discountWithoutCld, locale = 'en' }) {
  const spanText = isCartBelowThreshold
    ? i18n.t('navigation.cart_widget.potential_discount', { ns: 'rails', lng: locale })
    : i18n.t('navigation.cart_widget.discount_applied', { ns: 'rails', lng: locale })
  return (
    <Fragment>
      <span>{spanText}</span>
      <span className="potential-discount">
        <span className="text-semibold">
          {numeral(isCartBelowThreshold ? potentialDiscount : discountWithoutCld).format('$0.00')}
        </span>
      </span>
    </Fragment>
  )
}

DiscountInfo.propTypes = {
  isCartBelowThreshold: bool.isRequired,
  potentialDiscount: number.isRequired,
  discountWithoutCld: number.isRequired,
  locale: string,
}

export default DiscountInfo
